<template>
  <div class="v-view chart-view a-fadeIn" :style="{ height: span * 33.33 + '%' }">
    <div class="v-title">{{ title }}</div>
    <div class="ElderlyData-content" >
      <div class="E-number">
        <!-- <div class="pointer" @click="toElder"> -->
        <div class="pointer">
          <p>老人总数</p>
          <p>{{ configerNumber.total + '人' }}</p>
        </div>
        <div class="pointer" @click="getElderDetil('全部')">
          <p>城乡低保</p>
          <p>{{ configerNumber.DBNumber + '人' }}</p>
        </div>
        <div>
          <p>分散供养特困</p>
          <p>{{ configerNumber.WBNumber + '人' }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Mixins} from '../minix/index'
import PubSub from 'pubsub-js'
import { mapGetters } from 'vuex'

export default {
  name: 'JCElderlyData',
  mixins:[Mixins],
  computed: {
    ...mapGetters(['cid']),
  },
  props: {
    type: {
      type: String,
      default: 'pie',
    },
    span: {
      type: Number,
      default: 1,
    },
    title: {
      type: String,
      default: '惠及困难老人数据',
    },
  },
  watch: {},
  data() {
    const configerNumber = this.$configer.elderData
    return {
      visible: false,
      configerNumber:configerNumber
    }
  },
  created() {
  },
  beforeDestroy() { },
  methods: {
    toElder(){
      let data = {
        name: "全部设备",
        total: "0",
        type: "",
        visible: true,
      }
      PubSub.publish("JCEqument", data);
    }
  },
}
</script>
<style lang="scss" scoped>
.pointer{
  cursor: pointer;
}
.ElderlyData-content {
  width: 100%;
  height: 100%;
  // background-color: red;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.E-number {
  width: 100%;
  height: 21.67vh;
  // background-color: pink;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0px 10px;

  div {
    width: 148px;
    height: 100%;
    background: url(../assets/images/jc/db.png) no-repeat center/auto 100%;

    p:first-child {
      padding-top: 13.5vh;
      margin-bottom: 1vh;
    }

    p {
      text-align: center;
    }

    p:last-child {
      background: -webkit-linear-gradient(#ffcb32, #ffe6bd);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      font-family: "pmzd";
      font-size: 26px;
    }
  }

  div:first-child {
    background: url(../assets/images/jc/total.png) no-repeat center/auto 100%;

    p:last-child {
      background: -webkit-linear-gradient(#00fcff, #bdf8ff);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      font-family: "pmzd";
      font-size: 26px;
    }
  }

  div:last-child {
    background: url(../assets/images/jc/wb.png) no-repeat center/auto 100%;

    p:last-child {
      background: -webkit-linear-gradient(#00ff9c, #c7ffe9);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      font-family: "pmzd";
    }
  }
}

.E-sex {
  width: 100%;
  height: 7.41vh;
  // background-color: pink;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0px 10px;

  div {
    width: 227px;
    height: 100%;
    padding: 10px 14px;
    padding-left: 60px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    background: url(../assets/images/yongning/nam.png) no-repeat center/ auto 100%;

    p {
      width: 100%;

      text-align: center;
    }

    p:last-child {
      background: -webkit-linear-gradient(#19d1f2, #069bfd);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      font-family: "pmzd";
      font-size: 26px;
    }
  }

  div:last-child {
    background: url(../assets/images/yongning/woman.png) no-repeat center/ auto 100%;

    p:last-child {
      background: -webkit-linear-gradient(#ed89b3, #d35d8f);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      font-family: "pmzd";
      font-size: 26px;
    }
  }
}
</style>
